import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Suspense } from 'react';
import ReduxProvider from './app/providers/ReduxProvider';
import ABTestProvider from './app/providers/ABTestProvider';
import AuthRedirect from './app/components/AuthRedirect';
import QueryParamHandler from './app/components/query-param-handler';
import HomePage from './app/pages/HomePage';
import ProfilePage from './app/pages/ProfilePage';
import OnboardingPage from './app/pages/OnboardingPage';
import AgentPage from './app/pages/AgentPage';
import WaitlistPage from './app/pages/WaitlistPage';
import AuthCallbackPage from './app/pages/AuthCallbackPage';
import LinkedInCallbackPage from './app/pages/LinkedInCallbackPage';

function App() {
  return (
    <ReduxProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Suspense fallback={null}>
          <ABTestProvider>
            <Suspense fallback={null}>
              <QueryParamHandler />
            </Suspense>
            <Suspense fallback={null}>
              <AuthRedirect />
            </Suspense>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/onboarding" element={<OnboardingPage />} />
              <Route path="/agent" element={<AgentPage />} />
              <Route path="/agent/waitlist" element={<WaitlistPage />} />
              <Route path="/api/auth/callback" element={<AuthCallbackPage />} />
              <Route path="/api/linkedin" element={<LinkedInCallbackPage />} />
            </Routes>
          </ABTestProvider>
        </Suspense>
      </BrowserRouter>
    </ReduxProvider>
  );
}

export default App;
